// import React from "react";
import { render } from "react-dom";
import "@smartsuite/react-ui/lib/styles.sass";
import "@smartsuite/smartdoc/lib/esm/styles.sass";

import { Demo } from "./Demo";

render(<Demo />, document.getElementById("root"));
